import { render, staticRenderFns } from "./ExplainReferCode.vue?vue&type=template&id=1a207aad&scoped=true&"
import script from "./ExplainReferCode.vue?vue&type=script&lang=ts&"
export * from "./ExplainReferCode.vue?vue&type=script&lang=ts&"
import style0 from "./ExplainReferCode.vue?vue&type=style&index=0&id=1a207aad&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a207aad",
  null
  
)

export default component.exports